import { withStyles } from '@material-ui/core';

import WarningMessage from './component';
import styles from './styles';

export default withStyles(styles)(WarningMessage);
